import { SectionHeader } from '@/components/shared/section-header'
import { BlokProps } from '@/lib/types'
import { FeatureTeaserLargeStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'
import { InteractiveVisual } from '../interactive/registry'
import { StoryblokImage } from '../shared/storyblok-image'

export function FeatureTeaserLarge({ blok }: BlokProps<FeatureTeaserLargeStoryblok>) {
  return (
    <section
      {...storyblokEditable(blok)}
      className="to-background from-sidebar bg-gradient-to-b py-32"
    >
      <div className="page-container space-y-16">
        <SectionHeader
          icon={blok.descriptorIcon}
          title={blok.title}
          preTitle={blok.descriptorTitle}
          content={blok.content}
          layout="stacked"
        ></SectionHeader>
        <div className="relative -mr-6 overflow-hidden lg:mr-0">
          {blok.visualMedia.filename && (
            <StoryblokImage
              image={blok.visualMedia}
              className="h-auto w-[800px] max-w-[unset] lg:w-full"
            />
          )}
          {blok.visual && (
            <InteractiveVisual
              componentId={blok.visual}
              className="h-auto w-[800px] max-w-[unset] lg:w-full"
            />
          )}
          <div className="to-background absolute top-0 bottom-0 h-full w-full bg-gradient-to-b from-transparent from-50%"></div>
        </div>
      </div>
    </section>
  )
}
